import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getAudioDetail } from '@/service/audioList';
import { AudioDto } from '@/service/type';
import { AudioDetailDto } from '@/service/interface';
import BgURL from './assets/bg.png';
import DiskBgURL from './assets/disk-bg.png';
import DiskLusterURL from './assets/disk-luster.png';
import ArmURL from './assets/arm.png';
import CoverURL from './assets/cover.png';
import TimerURL from './assets/timer.png';

import { WaveForm } from './WaveForm/index';
import { cn, displayDuration } from '@/utils';
import { useAudioPlayerStore } from '@/state/audio-player-store';
import { useRequest } from 'ahooks';
import { getShareAudio } from '@/service/share';
import { toast } from 'sonner';
import { Helmet } from 'react-helmet';

const Share: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { play, pause, isPlaying } = useAudioPlayerStore();

  if (!id) {
    return null;
  }
  // const { data } = useRequest(() => getAudioDetail({ id: id }))
  // const audioInfo = data?.data

  const [isRemoved, setIsRemoved] = useState(false);
  const { data: ShareData } = useRequest(() => getShareAudio({ id: id }), {
    onError: () => {
      setIsRemoved(true);
      toast.info('The track has been removed by the creator');
    },
  });
  const audioInfo = ShareData?.data;

  const title = `${audioInfo?.name} by ${audioInfo?.user?.name} | Jen`;
  const description = 'Ethically-Trained. High-Fidelity. Generative Audio Platform. Turn what’s in your mind into music. In seconds.';
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:image" content={`${window.location.origin}/open-graph/jen-brain.png`} />
        <meta property="og:type" content="music.song" />
        <meta property="twitter:card" content="player" />
        <meta property="twitter:site" content="@jenmusicai" />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:image" content={`${window.location.origin}/open-graph/jen-square-logo.png`} />
        <meta property="twitter:player" content={`${window.location.origin}/embed/${id}`} />
        <meta property="twitter:player:stream" content={`${window.location.origin}/cdn/${audioInfo?.cdn_path}`} />
        <meta property="twitter:player:width" content="760" />
        <meta property="twitter:player:height" content="240" />
      </Helmet>
      <div className="w-full h-full bg-[#111] flex justify-center items-center">
        <div
          className="w-[358px] h-[535px] relative top-0 lg:top-[-262px]"
          style={{
            background: `url(${BgURL}) no-repeat`,
            backgroundSize: 'cover',
            transform: window.innerWidth > 1024 ? 'scale(2)' : 'scale(1)',
          }}
        >
          <div
            className=" absolute top-[29px] left-[19px] w-[320px] h-[320px]"
            style={{
              background: `url(${DiskBgURL}) no-repeat`,
              backgroundSize: 'cover',
            }}
          />
          <div
            className=" absolute top-[47px] left-[37px] w-[284px] h-[284px]"
            style={{
              background: `url(${DiskLusterURL}) no-repeat`,
              backgroundSize: 'cover',
            }}
          />

          <div
            className={cn(' absolute top-[59px] left-[48px]  w-[262px] h-[262px] animate-spin-slow')}
            style={{
              background: `url(${CoverURL}) no-repeat`,
              backgroundSize: 'cover',
              animationPlayState: isPlaying ? 'running' : 'paused',
            }}
          />
          <div
            className=" absolute top-[29px] left-[33px]  w-[320px] h-[320px] "
            style={{
              background: `url(${ArmURL}) no-repeat`,
              backgroundSize: 'cover',
            }}
          />

          <div className="content w-full h-[76px]  mt-[387px] px-[17px]  text-[#67666d]">
            <div className=" w-full h-full py-[7px] px-[5px] flex flex-col gap-[4px]">
              {audioInfo?.duration && <WaveForm songId={id} duration={audioInfo?.duration} />}
              <div className="flex justify-between font-pressura-mono text-[8px] leading-[8px]">
                <div>0:00</div>
                <div>{displayDuration(audioInfo?.duration)}</div>
              </div>
              <div
                className="w-full h-[8px]"
                style={{
                  background: `url(${TimerURL}) no-repeat`,
                  backgroundSize: 'cover',
                }}
              ></div>
              <div className="flex justify-between items-center gap-[8px]">
                <div className="text-[10px] leading-[14px] truncate">{audioInfo?.name}</div>
                <div className="font-pressura-mono text-[8px] leading-[8px]">{audioInfo?.user?.name}</div>
              </div>
            </div>
          </div>
          <div className={cn('control')}>
            <div
              className={cn('play absolute bottom-0 left-0 w-[165px] h-[55px]', {
                'cursor-not-allowed': isRemoved,
                'cursor-pointer': !isRemoved,
              })}
              onClick={() => {
                !isRemoved &&
                  audioInfo &&
                  play({
                    url: `/cdn/${audioInfo.cdn_path}`,
                    // url: `/api/v1/audio/mock_play_audio/${Math.random()}`,
                    name: audioInfo.name,
                    duration: audioInfo?.duration,
                    id,
                  });
              }}
            ></div>
            <div
              className={cn('pause absolute bottom-0 left-[167px] w-[55px] h-[55px]', {
                'cursor-not-allowed': isRemoved,
                'cursor-pointer': !isRemoved,
              })}
              onClick={() => {
                pause();
              }}
            ></div>
            <div
              onClick={() => {
                window.open('/', '_blank');
              }}
              className={cn('play absolute bottom-0 left-[224px] w-[55px] h-[55px] cursor-pointer')}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Share;
